import moment from 'moment';
import { providers } from '@tripian/core';
import Model, { Providers } from '@tripian/model';
import { ButterflyCardSlider, Button, CloseIconButton, Modal, PoiInfoImage, PoiInfoText, PoiRefCard, PreLoading, RefCard, ReservationDetails, TabMenu } from '@tripian/react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import AppNav from '../../App/AppNav/AppNav';
import TripAppMenu from '../../App/AppNav/TripMenu/TripAppMenu';
import { OVERVIEW, TRIP_PLAN } from '../../constants/ROUTER_PATH_TITLE';
import useFavorite from '../../hooks/useFavorite';
import usePlan from '../../hooks/usePlan';
import useReaction from '../../hooks/useReaction';
import useReservation from '../../hooks/useReservation';
import useTrip from '../../hooks/useTrip';
import IFavoritePoi from '../../models/IFavoritePoi';
import useLayoutPlan from '../TripPlan/hooks/useLayoutPlan';
import './Overview.scss';
import covid from './covid.png';

const OverviewPage = () => {
  const { tripReference, tripClear, tripFetch } = useTrip();
  const { favorites, loadingFavorites, favoriteAdd, favoriteDelete, loadingFavoritePoi } = useFavorite();
  const { plans, planFetch } = usePlan();
  const { reactions, reactionAdd, reactionDelete, loadingReactionStepList } = useReaction();
  const { yelpReservations, loadingReservation, reservationCancel } = useReservation();
  const { favoritesVisible, setFavoritesVisible, yourBookingsVisible, setYourBookingsVisible } = useLayoutPlan();

  const [covidWarning, setCovidWarning] = useState<boolean>(plans ? plans[plans.length - 1].generated_status === 0 : false);

  /* */
  /* */
  /* ******* POI INFO (TOP TEN - OUR PICKS FOR YOU) ******* */
  const [poiInfoModalState, setPoiInfoModalState] = useState<{ show: boolean; poiInfo?: Model.Poi; planDate?: string }>({ show: false });
  /* ******* POI INFO (TOP TEN - OUR PICKS FOR YOU)******* */
  /* */
  /* */

  /* */
  /* */
  /* ******* YELP RESERVATION DETAILS ******* */
  const [yelpReservationDetailsModalState, setYelpReservationDetailsModalState] = useState<{
    show: boolean;
    reservationDetails?: Providers.Yelp.ReservationInfo;
  }>({
    show: false,
  });
  /* ******* YELP RESERVATION DETAILS ******* */
  /* */
  /* */

  const { hash } = useParams<{ hash: string }>();
  const history = useHistory();

  document.title = OVERVIEW.TITLE;

  // common
  useEffect(() => {
    if (hash !== tripReference?.trip_hash) {
      tripClear();
      tripFetch(hash);
    }
  }, [hash, tripClear, tripFetch, tripReference]);

  // plans
  const [planWaiting, setPlanWaiting] = useState<boolean>(false);
  useEffect(() => {
    if (plans) {
      const nextPlan = plans.find((p) => p.generated_status === 0);
      if (nextPlan && planWaiting === false) {
        // console.log('request yoktu attım.');
        setPlanWaiting(true);
        planFetch(nextPlan.id).finally(() => {
          setPlanWaiting(false);
        });
      }
      // console.log('request var atmadım. Ya da next plan yok. Eto bitmiş.');
    }
  }, [planFetch, planWaiting, plans]);

  // yelp reservation cancel
  const memoizedReservationCancel = useCallback(
    (providerReservationId: string) => {
      if (providers.yelp === undefined) {
        // eslint-disable-next-line no-console
        console.warn('memoizedReservationCancel called with undefined api.yelp object');
        return Promise.resolve();
      }

      if (yelpReservations === undefined || tripReference?.city === undefined) {
        // eslint-disable-next-line no-console
        console.warn('memoizedReservationCancel called with undefined reservation');
        return Promise.resolve();
      }

      const currentReservation = yelpReservations?.find((reservation) => (reservation.value as Providers.Yelp.ReservationInfo).reservation_id === providerReservationId);

      if (currentReservation === undefined) {
        // eslint-disable-next-line no-console
        console.warn('memoizedReservationCancel called with unknown providerReservationId: ', providerReservationId);
        return Promise.resolve();
      }

      return reservationCancel(providerReservationId)?.then(() => {
        setYelpReservationDetailsModalState({ show: false });
      });
    },
    [reservationCancel, tripReference, yelpReservations],
  );

  // // our picks for you memos
  // const memoizedSteps = useMemo(() => {
  //   const steps: {
  //     all: { step: Model.Step; dayIndex: number }[];
  //   } = {
  //     all: [],
  //   };

  //   const allSteps = plans?.reduce((previousValue: { step: Model.Step; dayIndex: number }[], currentValue: Model.Plan, currentIndex: number) => {
  //     if (currentValue) {
  //       const willShowSteps = currentValue.steps.filter((step) => {
  //         const stepReaction = reactions?.find((userReaction) => userReaction.step_id === step.id);

  //         if (stepReaction) {
  //           if (stepReaction.reaction === Model.REACTION.THUMBS_DOWN) {
  //             if ((stepReaction.comment || '') !== '') {
  //               return false; // Dont show this step in butterfly!
  //             }
  //           }
  //         }

  //         return true; // show this step
  //       });

  //       const memoStep: { step: Model.Step; dayIndex: number }[] = willShowSteps.map((willShowStep) => ({
  //         step: willShowStep,
  //         dayIndex: currentIndex,
  //       }));
  //       return previousValue.concat(memoStep);
  //     }
  //     return previousValue;
  //   }, []);

  //   if (allSteps) {
  //     steps.all = allSteps.sort((a, b) => a.dayIndex - b.dayIndex).sort((a, b) => Math.round(b.step.score || 2) - Math.round(a.step.score || 2));
  //   } else {
  //     steps.all = [];
  //   }

  //   return steps;
  // }, [plans, reactions]);

  // our picks for you
  const memoizedThumbs = useCallback(
    (step: Model.Step) => {
      let t = 0;
      const stepReaction = reactions?.find((userReaction) => userReaction.step_id === step.id);
      if (stepReaction) {
        if (stepReaction.reaction === Model.REACTION.THUMBS_UP) {
          t = 1;
        } else if (stepReaction.reaction === Model.REACTION.THUMBS_DOWN) {
          t = -1;
        } else {
          // eslint-disable-next-line no-console
          console.warn('unknown step reaction', stepReaction.reaction);
        }
      } else {
        // console.log('no step reaction', step.id);
      }
      return t;
    },
    [reactions],
  );

  // our picks for you
  const memoizedThumbsClicked = useCallback(
    (step: Model.Step, thumbs: number) => {
      const userReactionRequest: Model.UserReactionRequest = {
        step_id: step.id,
        poi_id: step.poi.id,
        reaction: Model.REACTION.THUMBS_UP,
      };
      if (thumbs === -1) {
        userReactionRequest.reaction = Model.REACTION.THUMBS_DOWN;
      }
      reactionAdd(userReactionRequest);
    },
    [reactionAdd],
  );

  // our picks for you
  const memoizedThumbsUndo = useCallback(
    (step: Model.Step) => {
      const stepUserReaction = reactions?.find((userReaction) => userReaction.step_id === step.id);
      if (stepUserReaction) {
        reactionDelete(stepUserReaction.id, step.id);
      } else {
        // eslint-disable-next-line no-console
        console.error(`ButterflyCard.ThumbsUndo called with =${step.id}`);
      }
    },
    [reactionDelete, reactions],
  );

  // our picks for you
  const memoizedButterflyCardBodyClicked = useCallback((step: Model.Step, planDate: string) => {
    setPoiInfoModalState({ show: true, poiInfo: step.poi, planDate });
  }, []);

  // // our picks for you
  const memoizedIsFavorite = useCallback(
    (poiId?: number): boolean => {
      if (favorites) {
        return favorites.findIndex((favorite) => favorite.poi_id === poiId) > -1;
      }
      return false;
    },
    [favorites],
  );

  // our picks for you
  // const memoizedButterflyCardSliderShowLoadingCard = useMemo(() => {
  //   if (plans) {
  //     return plans[plans.length - 1].generated_status === 0;
  //   }
  // }, [plans]);

  // our picks for you
  const memoizedFavoriteToggle = useCallback(
    (addFavorite: boolean, poiId?: number) => {
      if (poiId) {
        if (addFavorite) {
          favoriteAdd(poiId);
        } else {
          const favoriteId = favorites?.find((favorite) => favorite.poi_id === poiId)?.id;
          if (favoriteId) {
            favoriteDelete(favoriteId, poiId);
          } else {
            // eslint-disable-next-line no-console
            console.error('memoizedFavoriteToggle favorite delete error: Can not found poi id in favorite list', addFavorite, poiId, favorites);
          }
        }
      }
    },
    [favoriteAdd, favoriteDelete, favorites],
  );

  /* */
  /* */
  /* ******** TAB MENU ******** */
  const tabMenu = useMemo(
    () => (
      <>
        {/* <div className="trip-tab-menu-fake" /> */}
        <div className="col trip-tab-menu">
          <TabMenu
            menuItems={[
              {
                title: 'OVERVIEW',
                onClick: () => {},
              },
              {
                title: 'ITINERARY PLANNER',
                onClick: () => {
                  history.push(`${TRIP_PLAN.PATH}/${hash}`);
                },
              },
            ]}
            selectedIndex={0}
          />
        </div>
      </>
    ),
    [hash, history],
  );
  /* ******** TAB MENU ******** */
  /* */
  /* */

  /* */
  /* */
  /* ******* POI INFO MODAL (OUR PICKS FOR YOU)  ******* */
  const poiInfoModal = useMemo(
    () => (
      <Modal
        show={poiInfoModalState.show}
        className="overview-guide-poi-info-modal scrollable-y"
        backdropClick={() => {
          setPoiInfoModalState({ show: false });
        }}
      >
        {poiInfoModalState.poiInfo ? (
          <div className="row mb0">
            <div className="col col12 col6-m p0 mb0">
              <PoiInfoImage
                poi={poiInfoModalState.poiInfo}
                favoriteClick={(favorite: boolean) => memoizedFavoriteToggle(favorite, poiInfoModalState.poiInfo?.id)}
                favorite={memoizedIsFavorite(poiInfoModalState.poiInfo.id)}
                favoriteLoading={loadingFavoritePoi(poiInfoModalState.poiInfo?.id)}
                close={() => {
                  setPoiInfoModalState({ show: false });
                }}
                square
              />
            </div>
            <div className="col col12 col6-m p0 mb0">
              <PoiInfoText poi={poiInfoModalState.poiInfo} hideBookingButton planDate={poiInfoModalState.planDate} />
            </div>
          </div>
        ) : null}
      </Modal>
    ),

    [loadingFavoritePoi, memoizedFavoriteToggle, memoizedIsFavorite, poiInfoModalState.planDate, poiInfoModalState.poiInfo, poiInfoModalState.show],
  );
  /* ********* POI INFO MODAL (OUR PICKS FOR YOU)********* */
  /* */
  /* */

  const covidWarningMessage = useMemo(
    () =>
      covidWarning ? (
        <div className="covid-warn">
          <img alt="Covid-19 Updates" src={covid} className="covid-warn-logo" />
          <span className="covid-warn-text">
            Please be advised that due to COVID-19 restrictions, temporarily or permanently closed locations are not displayed.
            <br />
            <span className="covid-warn-text-sub">Latest Database Update: Dec 16 2020.</span>
          </span>
          <div
            role="button"
            className="covid-warn-close"
            tabIndex={0}
            onKeyDown={() => {}}
            onClick={() => {
              setCovidWarning(false);
            }}
          >
            X
          </div>
        </div>
      ) : null,
    [covidWarning],
  );

  /* */
  /* */
  /* ******* OUR PICKS FOR YOU ******* */
  const ourPickForYou = useMemo(() => {
    const days = plans?.map((plan, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div key={`ourPickForYou-day-${index}`}>
        <h2 className="our-pick-day-header mt10">
          {moment(plan.date).format('MMM D')} - Day {index + 1}
        </h2>
        <div className="my5 overview-guide-px">
          {plan.generated_status === 0 ? (
            <div style={{ height: '370px' }}>
              <PreLoading />
            </div>
          ) : (
            <ButterflyCardSlider
              steps={plan.steps.map((step) => ({ step, dayIndex: index }))}
              getThumbsNumber={memoizedThumbs}
              thumbsClicked={memoizedThumbsClicked}
              thumbsUndo={memoizedThumbsUndo}
              comment={() => {}}
              bodyClicked={(s: Model.Step) => {
                memoizedButterflyCardBodyClicked(s, `${plan.date} ${plan.start_time}`);
              }}
              loadingSteps={loadingReactionStepList.map((reactionStep: number) =>
                // Todo we should decide using comment and step replace with user reaction. thumbsloading hardcoded added
                ({ stepId: reactionStep, thumbsLoading: true }),
              )}
            />
          )}
        </div>
      </div>
    ));

    return (
      <div className="container-fluid pb10">
        {covidWarningMessage}
        <h2 className="our-pick-header pt10">OUR PICKS FOR YOU</h2>
        <span className="our-pick-sub-header our-pick-header-desc my2">Based on your preferences, we picked the following spots and created day-by-day itineraries for you.</span>
        {days || (
          <div style={{ height: '370px' }}>
            <PreLoading />
          </div>
        )}
      </div>
    );
  }, [covidWarningMessage, loadingReactionStepList, memoizedButterflyCardBodyClicked, memoizedThumbs, memoizedThumbsClicked, memoizedThumbsUndo, plans]);
  /* ******* OUR PICKS FOR YOU ******* */
  /* */
  /* */

  /* */
  /* */
  /* ******* FAVORITES MODAL***** */
  const favoriteModalRenderContent = useCallback(() => {
    if (loadingFavorites && favorites === undefined)
      return (
        <div className="overview-guide-modal-loading">
          <PreLoading />
        </div>
      );

    if (favorites) {
      if (favorites.length === 0)
        return (
          <div className="center mt8">
            <span>No favorites yet.</span>
          </div>
        );

      return favorites.map((favoritePoi: IFavoritePoi) =>
        loadingFavoritePoi(favoritePoi.poi_id) ? (
          <div key={`favorite-poi-ref-card-loading-${favoritePoi.id}`} className="favorite-items-loading">
            <PreLoading key={`favorite-poi-ref-card-${favoritePoi.id}`} />
          </div>
        ) : (
          <PoiRefCard
            key={`favorite-poi-ref-card-${favoritePoi.id}`}
            poi={favoritePoi.poi}
            buttonType={-1}
            poiCardClicked={() => {
              setPoiInfoModalState({ show: true, poiInfo: favoritePoi.poi });
            }}
            addRemoveAlternativePoi={(poi: Model.Poi) => {
              const currentFavoriteId = (favorites || []).find((f) => f.poi_id === poi.id)?.id;
              if (currentFavoriteId) {
                favoriteDelete(currentFavoriteId, poi.id);
                // eslint-disable-next-line no-console
              } else console.error('Overview: favoriteDeleteAndFetch called with unknown favorite id');
            }}
          />
        ),
      );
    }

    return null;
  }, [favoriteDelete, favorites, loadingFavoritePoi, loadingFavorites]);

  const favoritesModal = useMemo(
    () => (
      <Modal
        className="scrollable-y"
        show={favoritesVisible}
        backdropClick={() => {
          setFavoritesVisible(false);
        }}
      >
        <div className="row m0">
          <div className="col col12  p5 m0">
            <h3 className="center">Favorites</h3>
            <div className="overview-guide-modal-close-icon m2">
              <CloseIconButton
                fill="#fff"
                clicked={() => {
                  setFavoritesVisible(false);
                }}
              />
            </div>
            {favoriteModalRenderContent()}
          </div>
        </div>
      </Modal>
    ),
    [favoritesVisible, favoriteModalRenderContent, setFavoritesVisible],
  );
  /* ******* FAVORITES MODAL ******* */
  /* */
  /* */

  /* */
  /* */
  /* ******* YELP RESERVATION DETAILS MODAL***** */
  const yelpReservationDetailsModal = useMemo(
    () => (
      <Modal
        show={yelpReservationDetailsModalState.show}
        className="booking-modal p5"
        backdropClick={() => {
          if (!loadingReservation) setYelpReservationDetailsModalState({ show: false });
        }}
      >
        <div className="row m0">
          <div className="overview-guide-modal-close-icon m2">
            <CloseIconButton
              fill="#fff"
              clicked={() => {
                if (!loadingReservation) setYelpReservationDetailsModalState({ show: false });
              }}
            />
          </div>
          {yelpReservationDetailsModalState.reservationDetails ? (
            <div>
              {loadingReservation ? (
                <div className="create-update-trip-loading">
                  <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
                </div>
              ) : null}
              <div>
                <ReservationDetails reservationInfo={yelpReservationDetailsModalState.reservationDetails} />
              </div>
              <div className="row center">
                <div>
                  <Button
                    color="primary"
                    text="Cancel Reservation"
                    onClick={() => {
                      setYelpReservationDetailsModalState((prevState) => ({
                        ...prevState,
                      }));
                      memoizedReservationCancel(yelpReservationDetailsModalState.reservationDetails?.reservation_id || '');
                    }}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </Modal>
    ),
    [yelpReservationDetailsModalState.show, yelpReservationDetailsModalState.reservationDetails, loadingReservation, memoizedReservationCancel],
  );
  /* ******* YELP RESERVATION DETAILS MODAL***** */
  /* */
  /* */

  /* */
  /* */
  /* ******* YOUR BOOKINGS MODAL***** */
  const yourBookingsModal = useMemo(
    () => (
      <Modal
        className="taste-info-your-bookings-modals scrollable-y"
        show={yourBookingsVisible}
        backdropClick={() => {
          setYourBookingsVisible(false);
        }}
      >
        <div className="row m0">
          <div className="col col12 p5  m0">
            <div className="overview-guide-modal-close-icon m2">
              <CloseIconButton
                fill="#fff"
                clicked={() => {
                  setYourBookingsVisible(false);
                }}
              />
            </div>
            <h3 className="center">Your Bookings</h3>
            {yelpReservations?.length === 0 ? (
              <div className="center mt8">
                <span>No bookings yet.</span>
              </div>
            ) : (
              yelpReservations?.map((yelpReservation) => {
                const yelpReservationInfo = yelpReservation.value as Providers.Yelp.ReservationInfo;
                return (
                  <div key={yelpReservationInfo.reservation_id} className="pt4">
                    <RefCard
                      image={yelpReservationInfo.restaurant_image}
                      title={yelpReservationInfo.restaurant_name}
                      butonText="VIEW RESERVATION"
                      subContext={`Covers : ${yelpReservationInfo.reservation_details.covers === 1 ? '1 person' : `${yelpReservationInfo.reservation_details.covers} people`}`}
                      clicked={() => {
                        setYelpReservationDetailsModalState({ show: true, reservationDetails: yelpReservationInfo });
                      }}
                    >
                      Date: {`${yelpReservationInfo.reservation_details.date}`}
                      <br />
                      Time : {` ${yelpReservationInfo.reservation_details.time}`}
                    </RefCard>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </Modal>
    ),
    [yourBookingsVisible, yelpReservations, setYourBookingsVisible],
  );
  /* ******* YOUR BOOKINGS MODAL ******* */
  /* */
  /* */

  /* */
  /* */
  /* RENDERS */
  // if (loadings.trip) {
  //   return <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />;
  // }

  const modal = () => {
    if (yelpReservationDetailsModalState.show) return yelpReservationDetailsModal;
    if (poiInfoModalState.show) return poiInfoModal;
    if (favoritesVisible) return favoritesModal;
    return null;
  };

  return (
    <>
      <AppNav
        tripInfoHeader
        tripAppMenu={
          <TripAppMenu
            onClickBookings={() => {
              setYourBookingsVisible(true);
            }}
            onClickFavorites={() => {
              setFavoritesVisible(true);
            }}
          />
        }
      />

      {tabMenu}
      <div className="mb12 overview-guide-main-div" style={{ marginTop: '48px' }}>
        {yourBookingsModal}

        {ourPickForYou}

        {modal()}
      </div>
    </>
  );
};

export default OverviewPage;
